
import { useAuthenticatedCRMRequestConfig } from '@web/services/crm-api/hooks';
import { useGetEventById, useGetMemberEventsById } from '@web/services/crm-api/rest';


export function useGetEventWrapper(eventId: string) {
	const { memberId, status, requestConfig } = useAuthenticatedCRMRequestConfig();

	const eventQuery = useGetEventById(eventId, {
		query: {
			enabled: !memberId,
		},
	});

	const eventAuthQuery = useGetMemberEventsById(memberId, eventId, {
		query: {
			enabled: !!memberId && status === 'authenticated',
		},
		request: requestConfig,
	});

	return memberId && eventAuthQuery.isFetched ? eventAuthQuery : eventQuery;
}
